import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import { PermissionsService } from '../service/permissions.service';

@Injectable()
export class PermissionsGuard implements CanActivate {

  constructor(private permissionsService: PermissionsService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const componentData = route.data;
    if (componentData.permissions && componentData.permissions.length > 0 && !this.permissionsService.isPermitted(componentData.permissions)) {
        this.permissionsService.navigateToForbiddenPage(componentData.permissions[0].toLowerCase());
        return false;
    }
    return true;
  }
}